import ActiveStorageUploader from '~/components/utils/rails_active_storage';

const getFileUrl = (fileName: string): string => `${process.env.ACTIVE_STORAGE_URL}/active_storage/${fileName}`;

type AWSUploadResult = {
  attachable_sgid: string;
  byte_size: number;
  checksum: string;
  content_type: string;
  created_at: string;
  filename: string;
  id: number;
  key: string;
  metadata: unknown;
  signed_id: string;
  url: string;
};

type UploadOptions = {
  file: File;
  token: string;
  onProgress?: (progress: number) => void;
};

interface Uploader {
  upload: (options: UploadOptions) => Promise<AWSUploadResult>;
}

const uploader: Uploader = {
  upload: ({ file, token, onProgress = undefined }) =>
    new Promise((resolve, reject) => {
      new ActiveStorageUploader({
        completeHandler: (error: string, data: Omit<AWSUploadResult, 'url'>) => {
          if (error) {
            reject(error);
          } else {
            resolve({ ...data, url: getFileUrl(data.key) });
          }
        },
        progressHandler: onProgress,
        token,
      }).upload(file);
    }),
};

export default uploader;
